import { operationsGlob } from "./operations";

const rootArea = "/inventory";

export const inventoryGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (typeCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${typeCode}/read`,
		operations: operationsGlob(`${baseArea}${rootArea}/${typeCode}`)
	})
});